import { CAMPAIGN_PURPOSES } from '@mm/api-routes';
import AuthenticatedController from './AuthenticatedController';

export default class CampaignPurposesController extends AuthenticatedController {
  static getAll() {
    return super.get(CAMPAIGN_PURPOSES);
  }
}
